import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewEncapsulation } from "@angular/core";
import { AuthenticationService } from "../services/authentication.service";
import { QueryLayersService } from "../services/query-layers.service";
import { AssetDetailService } from "../services/asset-detail.service";
import { EsriMapComponent } from "../esri-map/esri-map.component";
import { ButtonRenderComponent } from "./button.component";
import { Globals } from "../shared/globals";
import { environment } from "src/environments/environment";
import { GenericLayerService } from "../services/generic-layer.service";
import { CrewManagementService } from "../crewmanagement/crewmanagement.service";
import { GenericMapMethodsService } from "../services/generic-map-methods.service";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { EventEmittersService } from "../services/event-emitters.service";
import { UserService } from "src/app/services/user.service";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";
import { Subscription } from "rxjs";
import { faWindowClose } from "@fortawesome/free-regular-svg-icons";
import { faWrench } from "@fortawesome/free-solid-svg-icons";
import { GridOptions } from "ag-grid-community";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { CreateTaskComponent } from "../create-task/create-task.component";
import { AgGridAngular } from "ag-grid-angular";
import { MatTabsModule } from "@angular/material/tabs";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { NgIf, NgFor } from "@angular/common";
import { IUser } from "../interface/user";
import { ILayerSelections } from "../interface/selectedSet";

@AutoUnsubscribe()
@Component({
    selector: "sms-task-table",
    templateUrl: "./task-table.component.html",
    styleUrls: ["./task-table.component.scss"],
    host: { class: "myMaintananceDiv" },
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgIf, ConfigurableHeaderComponent, MatTabsModule, AgGridAngular, NgFor, CreateTaskComponent, TranslateModule, CustomTranslatePipe]
})
export class TaskTableComponent implements OnInit {
  /** Variables */
  @Input() Query: any;
  @Input() Graphic: any;
  @Input() QueryTask: any;
  @Input() map: any;
  @Input() tasksCategory: any;
  @Input() selectedData: ILayerSelections[] = [];
  @Input() FeatureLayer: any;
  @Input() all: any;
  @Input() Color: any;
  @Output() closeTable = new EventEmitter();
  @Input() PictureMarkerSymbol: any;
  @Input() JoinDataSource: any;
  @Output() showTask = new EventEmitter();  // not emitted
  @Output() rowDataObjVar = new EventEmitter();   // not emitted
  @Input() RelationshipQuery: any;
  // remove
  @Input() SimpleFillSymbol: any;
  @Input() SimpleLineSymbol: any;
  @Input() SimpleMarkerSymbol: any;
  @Input() Point: any;

  private myTasks: any[] = [];
  private currentUser: IUser;
  
  private openTasks: any[] = [];        // task records with Open status      are Inactive tasks propertly excluded?? 
  private completedTasks: any[] = [];   // task records with Closed status
  public rowData: any[] = [];           // starts as clone of openTask, but may have child asset tasks added. Used to populate the grid.
  public rowDataClosed = [];            // starts as clone of completedTasks, but may have child asset tasks added. Used to populate the grid
  private ignoreSelectedDataUpdates: boolean = false;

  private checked: boolean;
  
  showtask = false;
  private selectedDataTasks: any[] = [];
  public loading = false;
  changeWhileLoading_tabEvent = null;
  changeWhileLoading_assignedToEvent = null;
  private highlightAllAssets = true;
  activityLyrDomains;
  activityToolKitList = [];
  activityToolKitListGroup = [];
  components: any;
  rowSelection = "single";
  gridApi;
  gridColumnApi;
  showtools;
//  showtoolkitbtn = true;
  checkboxChecked = true;
  completionDateFrom: string;
  // TSDRSAM-1067 By Manikantha
  taskGraphicsLyr;
  activityTask;
  columnDefsOpen = [
    {
      headerName: this.translateService.instant("Mytasks.header.WorkOrder"),
      field: "WorkOrder"
    },
    { headerName: this.translateService.instant("Mytasks.header.AssetID"), field: "AssetID" },
    { headerName: this.translateService.instant("Mytasks.header.AssetCode"), field: "AssetCode" },
    { headerName: this.translateService.instant("Mytasks.header.AssetName"), field: "AssetName" },
    {
      headerName: this.translateService.instant("Mytasks.header.Activity"),
      field: "Activity",
      sort: "asc",
      cellRenderer: "cellRendererComponent",
      cellRendererParams: {
        onClick: this.onActivityClicked.bind(this)
      }
    },
    { headerName: this.translateService.instant("Mytasks.header.Route"), field: "Route", cellRenderer: (params) => (params.value ? params.value : "-") },
    { headerName: "Assigned To", field: "Worker", cellRenderer: (params) => (params.value ? params.value : "-") }
  ];

  gridOptions: GridOptions = {
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: true
    },
    getRowId: (params) =>  params.data.MaintID
  };

  // Closed Tasks  Grid Related
  gridApiClosed;
  gridColumnApiClosed;
  columnDefsClosed = [
    {
      headerName: this.translateService.instant("Mytasks.header.WorkOrder"),
      field: "WorkOrder"
    },
    { headerName: this.translateService.instant("Mytasks.header.AssetID"), field: "AssetID" },
    { headerName: this.translateService.instant("Mytasks.header.AssetCode"), field: "AssetCode" },
    { headerName: this.translateService.instant("Mytasks.header.AssetName"), field: "AssetName" },
    {
      headerName: this.translateService.instant("Mytasks.header.Activity"),
      field: "Activity",
      cellRenderer: "cellRendererComponent",
      cellRendererParams: {
        onClick: this.onActivityClicked.bind(this)
      }
    },
    { headerName: this.translateService.instant("Mytasks.header.Route"), field: "Route", cellRenderer: (params) => (params.value ? params.value : "-") },
    { headerName: "Completed By", field: "CompletedBy", cellRenderer: (params) => (params.value ? params.value : "-") }
  ];

  // Closed Tasks  Grid Related

  private gridApiOpt;
  private gridColumnApiOpt;
  faWindowClose = faWindowClose;
  faWrench = faWrench;
  columnDefsOpt = [
    {
      headerName: this.translateService.instant("Mytasks.header.Sequence"),
      field: "Task_Sequence",
      cellRenderer: (params) => (params.value ? params.value : "-")
    },
    {
      headerName: this.translateService.instant("Mytasks.header.WorkOrder"),
      field: "WorkOrder"
    },
    { headerName: this.translateService.instant("Mytasks.header.AssetID"), field: "AssetID" },
    { headerName: this.translateService.instant("Mytasks.header.AssetCode"), field: "AssetCode" },
    { headerName: this.translateService.instant("Mytasks.header.AssetName"), field: "AssetName" },
    {
      headerName: this.translateService.instant("Mytasks.header.Activity"),
      field: "Activity",
      //sort: "asc",
      cellRenderer: "cellRendererComponent",
      cellRendererParams: {
        onClick: this.onActivityClicked.bind(this)
      }
    },
    { headerName: this.translateService.instant("Mytasks.header.Route"), field: "Route", cellRenderer: (params) => (params.value ? params.value : "-") }
  ];
  activeTabType = "Open";
  subsUserRoles: Subscription;
  subsTasksModified: Subscription;
  subsEmitOpenDetailedMaintenance: Subscription;
  subsEmitClosedDetailedMaintenance: Subscription;
  assetNameArray: string[] = [];
  getAllFeaturesSubscribe: Subscription;
  getFilteredFeaturesByFieldSubscribe: Subscription;


  ////Added for ADA -- 8/27/26 tries to enable Enter press to toggle Assigned To Me checkbox. Does
  ////                 not work as the id is now a Material assigned value.
  ////                 Spacebar does toggle (Material internal behavior?) which is the acceptated.
  ////                 In any case, shouldn't this have been in the Header component??
  // @HostListener("document:keydown.enter", ["$event"])
  // onKeydownHandler(event: KeyboardEvent) {
  //   if (event.target["type"] === "checkbox" && event.target["id"] === "assigntome") {
  //     if ((<HTMLInputElement>event.target).checked) {
  //       (<HTMLInputElement>event.target).checked = false;
  //     } else {
  //       (<HTMLInputElement>event.target).checked = true;
  //     }
  //     this.assignedToChanged(event);
  //   }
  // }
  //
  constructor(
    private authenticationService: AuthenticationService,
    private queryLayersService: QueryLayersService,
    private assetDetail: AssetDetailService,
    public esritools: EsriMapComponent,
    public objGlobals: Globals,
    private genericLayerService: GenericLayerService,
    private crewManagementService: CrewManagementService,
    private assetDetailService: AssetDetailService,
    public genericMapMethodsService: GenericMapMethodsService,
    private translateService: TranslateService,
    public eeService: EventEmittersService,
    private userService: UserService
  ) {
    this.assetNameArray = [];
    this.currentUser = this.authenticationService.currentUserValue;

    this.eeService.userLayers.filter(layer => layer.type == "inventory" && layer.visible).forEach( (layer) => {
      // collect current user's asset class names
      this.assetNameArray.push(layer.name);
      // RSAM JIRA ID 1101
      if (layer.name == "Support") {
        // child assets as well
        if (this.currentUser.assignedAssetClasses!.find( ac => ac.layerId === this.currentUser.tableIds.signId) ) {
          this.assetNameArray.push("Sign");
        }
        if (this.currentUser.assignedAssetClasses!.find( ac => ac.layerId === this.currentUser.tableIds.lightId) ) {
          this.assetNameArray.push("Light");
        }
      }
    });

    this.subsUserRoles = this.userService.getRoleslist().subscribe((evt) => {
      this.objGlobals.userRoles = evt;
    });
    this.components = { cellRendererComponent: ButtonRenderComponent };
    this.subsTasksModified = this.assetDetailService.tasksModified.subscribe((result) => {
      this.getSelectedDataTasks(this.selectedData, this.checkboxChecked);
    });
    this.subsEmitOpenDetailedMaintenance = this.eeService.emitOpenDetailedMaintenance.subscribe((tasks) => {
      this.openTasks = tasks.tasks;
      this.rowData = [...this.openTasks];  // clone it

      if (this.gridApi) {
        this.gridApi.setGridOption("rowData", this.rowData);
        this.gridApi.sizeColumnsToFit();
      }
      if (this.gridApiOpt) {
        this.gridApiOpt.setRowData(this.rowData);
        this.gridApiOpt.sizeColumnsToFit();
      }
      if (!this.selectedData || this.selectedData.length === 0 || this.ignoreSelectedDataUpdates) {
        this.addGrapicsBasedOnTab("Open", this.openTasks);
      }
      // TSDRSAM-1067 By Manikantha
      this.groupByToolkitrecords(this.openTasks, this.activityToolKitList);
      this.loading = false;
      this.checkLoadQueue();
    });
    this.subsEmitClosedDetailedMaintenance = this.eeService.emitClosedDetailedMaintenance.subscribe((closedtasks) => {
      this.completedTasks = closedtasks.tasks;
      this.rowDataClosed = [];
      console.log(closedtasks);
      for (let i = 0; i < this.completedTasks.length; i++) {
        this.rowDataClosed.push(this.completedTasks[i]);
      }

      if (this.gridApiClosed) {
        this.gridApiClosed.setGridOption("rowData", this.rowDataClosed);
        this.gridApiClosed.sizeColumnsToFit();
      }
      // RSAN JIRA ID 941
      if (!this.selectedData || this.selectedData.length === 0) {
        this.addGrapicsBasedOnTab("Closed", this.completedTasks);
      }
      this.loading = false;
      this.checkLoadQueue();
    });
    //TSDRSAM-3110
    this.eeService.emitTaskCreateFormOpened.subscribe((isCreateTaskOpen) => {
      this.showtask = false;
    });
    //added 12/28/25 defer opening create/edit task until task's asset is registered so correct worker list is genereated
    this.eeService.emitActiveAssetInfo.subscribe((activeAsset) => {
      if(this.activityTask && this.activityTask.data.AssetID == activeAsset[0].AssetID){
        this.showtask = false;
        this.openTaskEditorAg(this.activityTask);
        this.activityTask = null;
      }
    });

    this.genericMapMethodsService.emitSelectedGraphicsOnMap.subscribe((indexes) => {
      if (this.gridApi){
        this.gridApi.deselectAll();
        const AssetID = this.eeService.selectedSet[indexes.layerIndex].Data[indexes.assetIndex].attributes.AssetID;
        this.gridApi.forEachNode( (node) => {
          if (node.data.AssetID === AssetID || node.data.ParentID === AssetID) {
            node.setSelected(true);
            if (node.rowIndex !== null) {
              this.gridApi.ensureIndexVisible(node.rowIndex, "middle");
            }
          }
        });
      }
    });

  }

  ngOnInit(): void {
    // TSDRSAM-1067 By Manikantha
    if (this.map.getLayer("sms-tasks-layer")) {
      this.taskGraphicsLyr = this.map.getLayer("sms-tasks-layer");
    } else {
      this.taskGraphicsLyr = new this.genericMapMethodsService.GraphicsLayer({ id: "sms-tasks-layer" });
      this.map.addLayer(this.taskGraphicsLyr);
    }
    this.taskGraphicsLyr.on( "click", (evt) => { 
      let AssetID;
      if (evt.graphic.attributes.ParentID) {
        AssetID = evt.graphic.attributes.ParentID;
      } else {
        AssetID = evt.graphic.attributes.AssetID;
      }
      // TSSDRSAM 1109
      if (this.gridApi){
        this.gridApi.deselectAll();
        this.gridApi.forEachNode( (node) => {
          if (node.data.AssetID === AssetID || node.data.ParentID === AssetID) {
            node.setSelected(true);
            if (node.rowIndex !== null) {
              this.gridApi.ensureIndexVisible(node.rowIndex, "middle");
            }
          }
        });
      }
      this.eeService.selectAssetForTaskRecord(evt.graphic.attributes);
    });
    const ftrLyrActivity = new this.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.activityId, { outFields: ["*"] });
    ftrLyrActivity.on(
      "Load",
      function (evt) {
        this.activityLyrDomains = evt.layer.types;
      }.bind(this)
    );
    this.loading = true;
    this.activityToolKitListGroup = [];

    this.getAllFeaturesSubscribe = this.genericLayerService.getAllFeatures(this.currentUser.tableIds.activityToolkitId).subscribe(
      function (results: any) {
        this.activityToolKitList = results.features;
        this.showtools = false;
      }.bind(this)
    );

    this.getSelectedDataTasks(this.selectedData, this.checkboxChecked);
    //Jira Id 935
    this.assetDetailService.getAssetIDFormat(this.Query, this.QueryTask, this.FeatureLayer);
    //ADA fix
    //document.getElementById("closeTaskTable").focus();

    //  var alertZ = document.getElementById('ag-20-of-page');
    //  alertZ.innerText ="hello"

    this.ignoreSelectedDataUpdates = this.selectedData?.length > 0 ? false : true;

  }
  ngOnDestroy(): void {
    // TSDRSAM-814
    this.map.graphics.clear();
    // TSDRSAM-1067 By Manikantha
    if (this.taskGraphicsLyr) this.taskGraphicsLyr.clear();
    this.gridApi = null;
    this.gridApiClosed = null;
    this.gridApiOpt = null;
  }

  showToolkit(): void {
    this.showtools = !this.showtools;
  }

  refreshGridData(): void {
    try {
      if (this.gridApi) {
        const rows = [];
        const closedRows = [];
        this.loading = true;

        for (let i = 0; i < this.rowData.length; i++) {
          const row = this.gridApi.getDisplayedRowAtIndex(i);
          rows.push(row);
        }

        for (let i = 0; i < this.rowDataClosed.length; i++) {
          const row = this.gridApi.getDisplayedRowAtIndex(i);
          closedRows.push(row);
        }

        this.gridApi.redrawRows({ rowNodes: rows });
        this.gridApi.sizeColumnsToFit();
        // // // if (this.gridApiOpt) {
        // // //   this.gridApiOpt.redrawRows({ rowNodes: rows });
        // // //   this.gridApiOpt.sizeColumnsToFit();
        // // // }
        // // // this.gridApiClosed.redrawRows({ rowNodes: closedRows });
        // // // this.gridApiClosed.sizeColumnsToFit();
      }
    } catch (error) {
      console.error(error);
    }
  }
  onGridReadyOpen(evtOpen): void {
    try {
      this.gridApi = evtOpen.api;
      this.gridColumnApi = evtOpen.api;
      this.gridApi.sizeColumnsToFit();
    } catch (error) {
      console.error(error);
    }
  }
  onGridReadyClosed(evtClosed): void {
    try {
      this.gridApiClosed = evtClosed.api;
      this.gridColumnApiClosed = evtClosed.api;
      this.gridApiClosed.sizeColumnsToFit();
    } catch (error) {
      console.error(error);
    }
  }
  onGridReadyOpt(evtOpt): void {
    try {
      this.gridApiOpt = evtOpt.api;
      this.gridColumnApiOpt = evtOpt.columnApi;
      this.gridApiOpt.sizeColumnsToFit();
    } catch (error) {
      console.error(error);
    }
  }
  onActivityClicked(selectedRow): void {
    try {
      this.showtask = false;
      if (this.eeService.activeAssetInfo && this.eeService.activeAssetInfo[0]?.AssetID == selectedRow.data.AssetID){
        this.openTaskEditorAg(selectedRow);
      } else {
        this.activityTask = selectedRow;
      }
    } catch (error) {
      console.error(error);
    }
  }
  onSelectionChangedOpen(evt): void {
    const selectedRows = evt.api.getSelectedRows();
    if (selectedRows){ this.selectRowDataAg(selectedRows); }
  }
  onSelectionChangedOpt(evt): void {
    const selectedRows = evt.api.getSelectedRows();
    if (selectedRows){ this.selectRowDataAg(selectedRows); }
  }
  onSelectionChangedClosed(evt) {
    const selectedRows = evt.api.getSelectedRows();
    if (selectedRows){ this.selectRowDataAg(selectedRows); }
  }
  tabChanged(event) {
    if (event.index == 1) {
      //name = "closed";
      this.activeTabType = "Closed"
    } else {
      //name = "open";
      this.activeTabType = "Open"
    }

    if (this.loading){
      this.changeWhileLoading_tabEvent = event; // TSDRSAM-3109
    }
    else {
      this.eeService.setAssetViewer(false);
      try {
        this.getSelectedDataTasks(this.selectedData, this.checkboxChecked);
        this.refreshGridData();
      } catch (error) {
        console.error(error);
      }
    }
  }

  // getOpenAndCompletedTasks(myTasks) {  //todo obsolete? if so, delete
  //   try {
  //     this.rowData = [];
  //     this.rowDataClosed = [];

  //     if (myTasks.length <= 0) {
  //       this.loading = false;
  //     } else {
  //       // 16 hours = 57600000(16 * 60 * 60 *1000)
  //       this.completedTasks = myTasks.filter((task) => task.attributes.Status === "Closed" && task.attributes.CompletionDate > new Date(Date.now() - 1).getTime() - 57600000);
  //       console.log(this.completedTasks);
  //       // tslint:disable-next-line:prefer-for-of
  //       for (let i = 0; i < this.completedTasks.length; i++) {
  //         this.rowDataClosed.push(this.completedTasks[i].attributes);
  //       }

  //       if (this.gridApiClosed) {
  //         this.gridApiClosed.setGridOption("rowData", this.rowDataClosed);
  //         this.gridApiClosed.sizeColumnsToFit();
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  getSelectedDataTasks(data, assignedToMe) {
    const tasksFilter: { [key: string]: any } = {};
    try {

      if (this.ignoreSelectedDataUpdates) { data = null; } 
      if (data) {
        const assetIDsList: any[] = [];
        data.forEach((layer) => {
          layer.Data.forEach((asset) => {
            if (asset.attributes.AssetID) {
              assetIDsList.push(asset.attributes.AssetID);
            }
          });
        });
        if (assetIDsList.length > 0)
        {
          console.log("selected from map");
          tasksFilter["AssetID"] = assetIDsList;
        }
      }

      tasksFilter["AssetName"] = this.assetNameArray;
      tasksFilter["Region" + this.currentUser.selectedRegion.regionLevel] = [this.currentUser.selectedRegion.regionName.toString()];
      if (assignedToMe) {
        tasksFilter["Worker"] = [this.currentUser.username];
      }

      if (this.activeTabType == "Open") {  // RSAM JIRA ID 941
        tasksFilter["Status"] = ["Open"]; 
        tasksFilter["AssetStatus"] = ["Active"];
        this.eeService.getUpdatedDetailedMaintenance(tasksFilter, "Open");
      }
      else if (this.activeTabType == "Closed") {
        tasksFilter["Status"] = ["Closed"],     
        tasksFilter["CompletionDateFrom"] = new Date(new Date(Date.now() - 1).getTime() - 57600000).toISOString(); // last 16 hours (16 * 60 * 60 *1000)
        //Don't filter to Active assets -- show all recently completed tasks 
        this.eeService.getUpdatedDetailedMaintenance(tasksFilter, "Closed");
      }
      else {} // optimized ... when we get around to implementing it

      // this.querySpacialRelatedTasks(data, assignedToMe);
    } catch (error) {
      console.error(error);
    }
  }

  querySpacialRelatedTasks(data, assignedToMe) {          //OBSOLETE?
    try {
      let count = 0;
      const intTasks = [];
      data.forEach(
        function (layer) {
          let idcsv = "";
          layer.Data.forEach((feature) => {
            idcsv += "'" + feature.attributes.AssetID + "',";
          });
          idcsv = idcsv.substring(0, idcsv.length - 1);
          this.getRecordsByIdsSubscribe = this.genericLayerService.getRecordsByIds(this.currentUser.tableIds.maintenanceId, idcsv).subscribe(
            function (results: any) {
              console.log(results);
              count++;

              if (results && results.features && results.features.length > 0) {
                // tslint:disable-next-line:prefer-for-of
                for (let ind = 0; ind < results.features.length; ind++) {
                  intTasks.push(results.features[ind]);
                }
              }

              if (count === data.length) {
                if (assignedToMe) {
                  this.myTasks = intTasks.filter(
                    function (task) {
                      if (task.attributes.Worker === this.currentUser.username) {
                        return task;
                      }
                    }.bind(this)
                  );
                } else {
                  this.myTasks = intTasks;
                }
              }
            }.bind(this)
          );
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }

  // TSDRSAM 1109
  selectRowDataAg(selectedRows) {
    if (!selectedRows || selectedRows.length === 0) {
      return;
    }
     try {
      let AssetID;
      if (selectedRows[0].ParentID) {
        AssetID = selectedRows[0].ParentID;
      } else {
        AssetID = selectedRows[0].AssetID;
      }
      if (selectedRows[0].GeomWKT) {
        const imageUrl = "assets/images/marker_orange.png";
        const width = 20;
        const height = 20;
        // TSDRSAM-975 By Manikantha
        const graphic = new this.Graphic(new this.Point(JSON.parse(selectedRows[0].GeomWKT)), new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
        graphic.setSymbol(new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
        graphic.setAttributes(selectedRows[0]);
        this.map.centerAndZoom(graphic.geometry, 15);
      }
      if (selectedRows[0].Status == "Closed" && (selectedRows[0].Activity == "Retire" || selectedRows[0].Activity == "Replace")){
        this.eeService.setAssetViewer(false); // jcc 071625 - started showing completed tasks for inactive assets, but do not want to load them into asset viewer
        return;
      } 
      this.eeService.selectAssetForTaskRecord(selectedRows[0]);
    } catch (error) {
      console.error(error);
    }
  }

  /*Selected from Select Tool*/
  setThis() {
    return this;
  }
  async getRelatedTasks(data, allObjectIDList, allOtherAttributes, isMyTask) {
    try {
      this.rowData = [];
      this.rowDataClosed = [];
      allObjectIDList.forEach(async (layer) => {
        if (layer.LayerName === "Support") {
          const relatedQuery = new this.RelationshipQuery();
          relatedQuery.objectIds = layer.RelatedData;

          relatedQuery.outFields = ["*"];
          relatedQuery.relationshipId = 5; // need to cofigure dynamically
          const _this = this.setThis();
          await layer.layerObj.queryRelatedFeatures(relatedQuery, function (result) {
            console.log("Related Result", result);
            layer.RelatedData.forEach((object) => {
              if (result[object] !== undefined && isMyTask) {
                if (result[object].features[0].attributes.Worker === "TestUser") {
                  let marker = "";

                  if (result[object].features[0].attributes.Status === "Closed") {
                    marker = "assets/images/marker_green.png";
                  } else {
                    marker = "assets/images/marker_blue.png";
                  }

                  _this.setMarker(object, marker, layer.layerObj);

                  /*Fetch Asset Code and Route */
                  const selectedAttributes = layer.OtherAttributes.filter((attr) => attr.ObjectID === object);
                  result[object].features[0].attributes.assetCode = selectedAttributes[0].AssetCode;
                  result[object].features[0].attributes.Route = selectedAttributes[0].Route;
                  _this.selectedDataTasks.push(result[object].features[0]);
                } else {
                  let marker = "";

                  if (result[object].features[0].attributes.Status === "Closed") {
                    marker = "assets/images/marker_green.png";
                  } else {
                    marker = "assets/images/marker_blue.png";
                  }

                  _this.setMarker(object, marker, layer.layerObj);

                  /*Fetch Asset Code and Route */
                  const selectedAttributes = layer.OtherAttributes.filter((attr) => attr.ObjectID === object);
                  result[object].features[0].attributes.assetCode = selectedAttributes[0].AssetCode;
                  result[object].features[0].attributes.Route = selectedAttributes[0].Route;
                  _this.selectedDataTasks.push(result[object].features[0]);
                }
              }
            });
            _this.openTasks = _this.selectedDataTasks.filter((task) => task.attributes.Status !== "Closed");
            _this.completedTasks = _this.selectedDataTasks.filter((task) => task.attributes.Status === "Closed");

            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.openTasks.length; i++) {
              this.rowData.push(this.openTasks[i].attributes);
            }

            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.completedTasks.length; i++) {
              this.rowDataClosed.push(this.completedTasks[i].attributes);
            }

            if (this.gridApi) {
              this.gridApi.setRowData(this.rowData);
              this.gridApi.sizeColumnsToFit();
            }

            if (this.gridApiOpt) {
              this.gridApiOpt.setRowData(this.rowData);
              this.gridApiOpt.sizeColumnsToFit();
            }

            if (this.gridApiClosed) {
              this.gridApiClosed.setRowData(this.rowDataClosed);
              this.gridApiClosed.sizeColumnsToFit();
            }
          });
        }
      });
    } catch (error) {
      console.error(error);
    }
  }
  setMarker(object, marker, layerObj) {
    try {
      const query = new this.Query();
      const queryTask = new this.QueryTask(layerObj.url);
      query.where = "OBJECTID=" + object;
      query.returnGeometry = true;
      const width = 20;
      const height = 20;
      const _this = this.setThis();
      const pictureMarker = new _this.PictureMarkerSymbol(marker, width, height);
      // TSDRSAM-975 By Manikantha
      pictureMarker.setOffset(0, 5);
      queryTask.execute(query, function (result) {
        if (result) {
          console.log("Not Set Marker", result);
          result.features[0].setSymbol(pictureMarker);
          // TSDRSAM-1067 By Manikantha
          // _this.map.graphics.add(result.features[0]);
          _this.taskGraphicsLyr.add(result.features[0]);
        }

        console.log("Set Marker", result);
      });
    } catch (error) {
      console.error(error);
    }
  }

  openTaskEditorAg(selectedRow) {
    try {
      this.objGlobals.selectedTask = selectedRow.data;
      this.objGlobals.userSelectedActivity = selectedRow.data.Activity;
      this.esritools.showCreateTaskForm(null, selectedRow.data);
    } catch (error) {
      console.error(error);
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  showTaksTab(event) {
    console.log("showing tasks");
    this.showtask = false;
  }
  closeSmartTable() {
    try {
      this.eeService.setAssetTable(false);
      this.closeTable.emit(true);
      // TSDRSAM-1067 By Manikantha
      if (this.taskGraphicsLyr) this.taskGraphicsLyr.clear();

      if (this.selectedData && this.selectedData.length > 0) {
        this.selectedData = [];
      }
      this.eeService.clearActiveAssetVariables();
      // For ADA story - by Subba
      let mainPageTools = document.querySelectorAll('[data-mainPageTabbing="yes"]');
      if (mainPageTools.length > 0) {
        mainPageTools.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });
      }
      let bMapTools = document.querySelectorAll('[data-BMapTabbing="yes"]');
      if (bMapTools.length > 0) {
        bMapTools.forEach((element) => {
          element.setAttribute("tabindex", "0");
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
  assignedToChanged(event) {
    try {
      this.checkboxChecked = event.checked;
      if (this.loading){
        this.changeWhileLoading_assignedToEvent = event; // TSDRSAM-3109
      }
      else
      {
        this.getSelectedDataTasks(this.selectedData, this.checkboxChecked);
        this.refreshGridData();
      }
    } catch (error) {
      console.error(error);
    }
  }

  groupByToolkitrecords(taskList, toolkitList) {
    try {
      const result = [];
      this.activityToolKitListGroup = [];
      taskList.reduce(
        function (res, value1, index) {
          // TSDRSAM-1067 By Manikantha
          if (value1.Status === "Open") {
            if (index === 0) {
              res = {};
            }

            const activityLyrDomainsDES = this.activityLyrDomains;
            // TSDRSAM-1067 By Manikantha
            const layerName = value1.AssetName;
            const toolkitlistForSelTask = toolkitList.filter(
              function (result) {
                const assetclassid = activityLyrDomainsDES?.filter(
                  function (element) {
                    if (element.name === layerName) {
                      return element;
                    }
                  }.bind(this)
                )[0].id;
                // TSDRSAM-1067 By Manikantha
                if (result.attributes.Activity === value1.Activity && result.attributes.AssetClass === assetclassid) {
                  return result;
                }
              }.bind(this)
            );

            toolkitlistForSelTask.forEach(function (tool) {
              if (!res[tool.attributes.ToolName]) {
                res[tool.attributes.ToolName] = {
                  toolName: tool.attributes.ToolName,
                  count: 0
                };
                result.push(res[tool.attributes.ToolName]);
              }

              res[tool.attributes.ToolName].count += 1;
            });
          }

          return res;
        }.bind(this),
        {}
      );
      console.log(result);
      this.activityToolKitListGroup = result;
    } catch (error) {
      console.error(error);
    }
  }

  addGrapicsBasedOnTab(status: string, listOfTasks): void {
    try {
      // TSDRSAM-1067 By Manikantha
      if (this.taskGraphicsLyr) this.taskGraphicsLyr.clear();
      for (let i = 0; i < listOfTasks.length; i++) {
        if (listOfTasks[i].Status === status) {
          let imageUrl = "";
          if (listOfTasks[i].Status === "Closed") {
            imageUrl = "assets/images/marker_blue.png";
          } else {
            imageUrl = "assets/images/marker_orange.png";
          }
          const width = 20;
          const height = 23;
          let conspoint;
          if (listOfTasks[i].Shape.slice(0, listOfTasks[i].Shape.indexOf(" ")) == "POINT") {
            conspoint = new this.Point(
              parseFloat(listOfTasks[i].Shape.slice(listOfTasks[i].Shape.indexOf("(") + 1, listOfTasks[i].Shape.split(" ", 2).join(" ").length)),
              parseFloat(listOfTasks[i].Shape.slice(listOfTasks[i].Shape.split(" ", 2).join(" ").length, listOfTasks[i].Shape.indexOf(")"))),
              this.map.spatialReference
            );
          }
          // TSDRSAM-693
          else {
            conspoint = new this.Point(
              parseFloat(listOfTasks[i].Shape.slice(listOfTasks[i].Shape.indexOf("(") + 1, listOfTasks[i].Shape.split(" ", 2).join(" ").length)),
              parseFloat(listOfTasks[i].Shape.slice(listOfTasks[i].Shape.split(" ", 2).join(" ").length, listOfTasks[i].Shape.split(",", 1).join(" ").length)),
              this.map.spatialReference
            );
          }
          // TSDRSAM-975 By Manikantha
          const graphic = new this.Graphic(conspoint, new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
          graphic.setAttributes(listOfTasks[i]);
          // TSDRSAM-975 By Manikantha
          graphic.setSymbol(new this.PictureMarkerSymbol(imageUrl, width, height).setOffset(0, 5));
          this.taskGraphicsLyr.add(graphic);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  checkLoadQueue(){  
    // TSDRSAM-3109. Debounce Tab or AssignedToMe changes - only process after active loading is complete.
    if (this.changeWhileLoading_tabEvent !== null){
      this.tabChanged(this.changeWhileLoading_tabEvent);
    }
    else if (this.changeWhileLoading_assignedToEvent !== null){
      this.assignedToChanged(this.changeWhileLoading_assignedToEvent);
    }
    this.changeWhileLoading_tabEvent = null;
    this.changeWhileLoading_assignedToEvent = null;
  }

}
